import { RootState } from '../rootReducer'

export const getNotificationCount = (state: RootState) =>
  state.notification.count
